import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { RootState } from "../../../../../redux/store";

type Props = {
    isModalOpened: boolean;
    setIsModalOpened: (v: boolean) => void;
    setIsValidateClickedModal: React.Dispatch<React.SetStateAction<boolean | number>>;
};

export function ConfirmationUpdate({
    isModalOpened,
    setIsModalOpened,
    setIsValidateClickedModal,
}: Props) {
    const { t } = useTranslation();
    const message = useSelector((s: RootState) => s.fidelity.message);
    const toggle = () => setIsModalOpened(!isModalOpened);

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader className="text-capitalize" toggle={toggle}>
                <span
                    style={{
                        fontFamily: "Segoe UI Semibold",
                        color: "#2b2828",
                        fontSize: "20px",
                    }}
                >
                    {capitalize(t("Alert"))}
                </span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {message}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={toggle}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsValidateClickedModal(true);
                        toggle();
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
